import { registerBottomSheets } from '../utils/registry';
import { BottomSheetComponent } from '../BottomSheetsManager/BottomSheetsManager.types';
import Info from './Info/Info';
import InfoImage from './InfoImage/InfoImage';
import InputSelect from './InputSelect/InputSelect';
import Confirmation from './Confirmation/Confirmation';
import Select from './Select/Select';
import AddressSearch from './AddressSearch/AddressSearch';

const bottomSheets = {
  AddressSearch,
  Info,
  InfoImage,
  InputSelect,
  Confirmation,
  Select,
};

registerBottomSheets('common', bottomSheets);

declare global {
  interface RegisteredBottomSheets {
    common: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}
